module.exports = __webpack_public_path__ + "static/favonius-sword-ba640640f79a0fc5d68f098cf7959d03.png";